<template>
    <div class="fst-LlmsTemplates">
        <div class="templates-header">
            <div class="title">
                <span >{{ $t('llms.templates.title') }}</span>
            </div>
            <el-link type="primary" class="ml-auto mr-3"
                     :underline="false" :title="$t('add')" icon="fas fa-plus" @click="edit()" />
            <el-link type="primary" :underline="false" :title="$t('update')" icon="fas fa-sync-alt" @click="refresh()" />
        </div>
        <div v-if="result.list.length" class="templates-list">
            <div class="templates-list-item" :ref="`template-${item.id}`" v-for="item in result.list" :key="item.id">
                <div class="name">
                    <el-link :underline="false" @click="edit(item)">{{ item.alias }}</el-link>
                </div>
                <div class="actions">
                    <el-link class="actions-item" type="primary" :underline="false" :title="$t('copy')" icon="fal fa-copy" @click="edit(item, true)" />
                    <el-link type="primary" class="actions-item" icon="fal fa-trash-alt" @click="handleDelete(item.id)" :underline="false" :title="$t('delete')" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapActions } from 'vuex';
    import LlmsTemplatesEditor from './LlmsTemplatesEditor.vue';

    export default {
        name: "LlmsTemplates",
        props: {
            llm: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                result: {
                    offset: 0,
                    total: 0,
                    list: []
                }
            }
        },
        mounted() {
            this.refresh();
        },
        methods: {
            ...mapActions('llm', ['getTemplates','deleteTemplate']),
            refresh() {
                this.getTemplates({request: {filter: {scriptIds: [this.llm.id]}}, prepare: {target: this.$el}}).then(data => {
                    this.result = data;
                });
            },
            edit(item, copy) {
                let id = item && item.id;
                let modal;
                let title = this.$tc('llms.templates.editor.title', id ? 2 : 1);
                if (copy) {
                    title = this.$t('llms.copy.title');
                }
                this.$modal.dialog(LlmsTemplatesEditor, {
                    title,
                    modalParams: {width: 1000},
                    ':id': id,
                    ':llm': this.llm,
                    ':copy': !!copy,
                    ':templates': this.result.list,
                    '@hasChangedFields': value => {
                        modal && (modal.dialog.buttons[1].disabled = !value);
                    },
                    buttons: [{
                        name: this.$t('check'),
                        type: 'primary',
                        handler: ({component}) => {
                            component.check();
                        }
                    }, {
                        name: this.$t('save'),
                        type: 'primary',
                        disabled: true,
                        handler: ({component, dialog}) => {
                            component.save().then(() => {
                                this.refresh();
                                if (copy) {
                                    dialog.close();
                                }
                            });
                        }
                    }, 'close']
                }).then(data => modal = data);
            },
            handleDelete(id){
                this.$confirm(this.$t('llms.msg.deleteConfirm'), 'Внимание', {
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    this.remove(id);
                }).catch(() => {
                });
            },
            remove(id) {
                let target = _.get(this.$refs, `template-${id}.0`);
                this.deleteTemplate({request: {ids: [id]}, prepare: {loader: {target, spinner: 'el-icon-loading'}}}).then(() => {
                    this.refresh();
                });
            }
        }
    }
</script>

<style lang="scss">
    @use "@/assets/imports.scss" as *;

    .fst-LlmsTemplates {
        position: relative;
        padding: 10px;
        .templates-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 4px;
            .title {
                font-weight: 400;
                text-transform: uppercase;
                font-size: .75rem;
            }
            .buttons {
                margin-left: 10px;
            }
        }
        .templates-list {
            margin-top: 8px;
            //border-top: 1px solid $iq-border-color-light;
            background: #fff;
            padding: 0 10px;
            border-radius: 4px;

            &-item {
                position: relative;
                display: flex;
                padding: 5px 0;
                border-bottom: 1px solid $iq-border-color-light;
                &:last-child{
                    border: none;
                    padding-bottom: 10px;

                }
                &:hover {
                    .actions {
                        opacity: 1;
                    }
                }
                .name {
                    flex: 1;
                    .el-link {
                        font-size: 12px;
                        vertical-align: text-bottom;
                    }
                }
                .actions {
                    display: inline-flex;
                    align-items: center;
                    margin-left: 10px;
                    opacity: 0;
                    transition: all .1s linear;
                    &-item {
                        height: 12px;
                        font-size: 12px;
                        &:not(:last-child) {
                            margin-right: 10px;
                        }
                        .el-link {
                            font-size: 12px;
                            vertical-align: super;
                        }
                    }
                }
            }
        }
    }
</style>
